import {
  useCollaborationHighlightStore,
  type CollaborationHighlightContext,
} from '@/stores/collaborationHighlightStore';

type SoundEffectHighlightRoute = {
  projectId: string;
  parentProjectId?: string | null;
  context: CollaborationHighlightContext;
};

export function getSoundEffectHighlightScope(soundEffectId: string): string {
  return `sound-effect:${soundEffectId}`;
}

export function getStoryboardSoundTrackHighlightScope(storyboardId: string): string {
  return `storyboard-sound-track:${storyboardId}`;
}

/** 点击音效条目：清除该条协作高亮。 */
export function acknowledgeSoundEffectTargetHighlight(params: {
  route: SoundEffectHighlightRoute;
  soundEffectId: string;
  dismissRouteScope: (scope: string) => void;
}): void {
  const { route, soundEffectId, dismissRouteScope } = params;
  const store = useCollaborationHighlightStore.getState();

  store.clearHighlight({
    projectId: route.projectId,
    parentProjectId: route.parentProjectId,
    context: route.context,
    targetType: 'sound_effect',
    targetId: soundEffectId,
  });

  dismissRouteScope(getSoundEffectHighlightScope(soundEffectId));
}

/** 点击看板音效轨道块：清除该分镜下音效协作高亮。 */
export function acknowledgeStoryboardSoundTrackHighlight(params: {
  route: SoundEffectHighlightRoute;
  storyboardId: string;
  dismissRouteScope: (scope: string) => void;
}): void {
  const { route, storyboardId, dismissRouteScope } = params;
  const store = useCollaborationHighlightStore.getState();

  for (const item of Object.values(store.byEventId)) {
    const event = item.event;
    if (
      event.targetType !== 'sound_effect' ||
      event.targetStoryboardId !== storyboardId ||
      event.context !== route.context
    ) {
      continue;
    }
    store.clearHighlight({
      projectId: route.projectId,
      parentProjectId: route.parentProjectId,
      context: route.context,
      targetType: 'sound_effect',
      targetId: event.targetId,
    });
  }

  dismissRouteScope(getStoryboardSoundTrackHighlightScope(storyboardId));
}
